import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export const router = Vue.router = new Router({
  mode: 'history',

  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },

  routes: [{
    path: '/',
    name: 'home',
    meta: {auth: false},
    component: require('@/components/PageHome')
  }, {
    path: '/register',
    name: 'register',
    meta: {auth: false},
    component: require('@/components/PageRegister')
  }, {
    path: '/login',
    name: 'login',
    meta: {auth: false},
    component: require('@/components/PageLogin')
  }, {
    path: '/activate/:token',
    name: 'activate',
    meta: {auth: false},
    component: () => import('@/components/PageActivation')
  }, {
    path: '/activate-alternative-email/:token',
    name: 'activate-alternative-email',
    meta: {},
    component: () => import('@/components/PageActivationAlternativeEmail')
  }, {
    path: '/feed',
    name: 'feed',
    meta: {auth: true},
    component: () => import('@/components/Feed/PageFeed')
  }, {
    path: '/hit/:id',
    name: 'hit',
    props: true,
    meta: {auth: true},
    component: () => import('@/components/Hit/PageHit')
  }, {
    path: '/player/:id',
    name: 'player',
    component: () => import('@/components/Player/PagePlayer')
  }, {
    path: '/players',
    name: 'players',
    meta: {auth: true},
    component: () => import('@/components/Player/PagePlayers')
  }, {
    path: '/challenge/:id',
    name: 'challenge',
    props: true,
    meta: {auth: true},
    component: () => import('@/components/PageChallenge')
  }, {
    path: '/404',
    name: 'page404',
    component: () => import('@/components/Page404')
  }, {
    path: '*',
    redirect: {
      name: 'page404'
    }
  }]
})

router.afterEach((to, from) => {
  document.documentElement.classList.remove('app-page-' + from.name)
  document.documentElement.classList.add('app-page-' + to.name)
  window.gtag && window.gtag('config', 'UA-97717342-1', {
    'page_title': to.name,
    'page_location': location.href,
    'page_path': '/' + to.path.replace('/', '')
  })
})



// WEBPACK FOOTER //
// ./src/config/router.js